import TextFieldMui from '@mui/material/TextField'
import styled from 'styled-components'

export const TextField = styled(TextFieldMui)`
    background-color: ${({ theme }) => theme.colors.white}
`
